import { TitleCasePipe } from '@angular/common';

export function titleCase( value: string | string[] ): string | string[] {
   if ( typeof value === 'string' ) {
      return new TitleCasePipe().transform( value );
   } else {
      return value.map( v => new TitleCasePipe().transform( v ));
   }
}
